export enum Decisions {
	Yes = 'Yes',
	No = 'No',
}

export type Decision = Decisions.Yes | Decisions.No;
